<template>
  <div>
    <MejoresMarcas v-if="esNeumaticos" />
    <BestBrandBattery v-if="esBaterias" />
  </div>
</template>

<script setup>

import MejoresMarcas from '~/components/MejoresMarcas.vue'
import BestBrandBattery from '~/components/Home/Battery/BestBrandBattery.vue'

import { NEGOCIOS } from "~/constants/negocios"

const modo_sistema = useState('modo_sistema');

// Computed properties mejoradas pero manteniendo tu lógica
const esNeumaticos = computed(() => modo_sistema.value === NEGOCIOS.NEUMATICOS)
const esBaterias = computed(() => modo_sistema.value === NEGOCIOS.BATERIAS)

</script>
